import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ServicePage from "./ServicePage";
import SpecialityPage from "./SpecialityPage";
import config from "../config";

const { API_BASE } = config;

const SPECIALITY_LINKS = ["commercial", "industrial", "household", "dehumidifiersales"];

async function fetchJSON(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status} – ${url}`);
  return res.json();
}

function ServiceDetailRouter() {
  const { slug } = useParams();

  // undefined = still checking category, otherwise { ownLink, parentLink }
  const [category, setCategory] = useState(undefined);

  useEffect(() => {
    let cancelled = false;
    setCategory(undefined);

    fetchJSON(`${API_BASE}/service-category.php?slug=${encodeURIComponent(slug)}`)
      .then((data) => {
        if (cancelled) return;
        setCategory({
          ownLink: data?.own_link ?? null,
          parentLink: data?.parent_link ?? null,
        });
      })
      .catch((err) => {
        console.error("ServiceDetailRouter category lookup failed:", err);
        if (!cancelled) setCategory({ ownLink: null, parentLink: null });
      });

    return () => { cancelled = true; };
  }, [slug]);

  // Both ServicePage and SpecialityPage already render null while their
  // own data loads, so this brief category check doesn't add any new
  // flash of empty content beyond what already existed.
  if (category === undefined) return null;

  const isSpeciality =
    SPECIALITY_LINKS.includes(category.ownLink) ||
    SPECIALITY_LINKS.includes(category.parentLink);

  return isSpeciality ? <SpecialityPage /> : <ServicePage />;
}

export default ServiceDetailRouter;